import { createFeature, createReducer, on } from '@ngrx/store';

import { AdministratorReadOnlySchema } from '@digitalforest/ngx-oak-api';

import { AdministratorActions } from './administrator.actions';

export interface AdministratorState {
  administrator: AdministratorReadOnlySchema | null;
}

export const initialState: AdministratorState = {
  administrator: null,
};

export const administratorFeature = createFeature({
  name: 'administrator',
  reducer: createReducer(
    initialState,
    on(AdministratorActions.loadSuccess, (state, { administrator }) => ({ ...state, administrator })),
    on(AdministratorActions.unload, (_state) => ({ ...initialState })),
  ),
});

export const { name, selectAdministratorState } = administratorFeature;
